import React, {memo} from 'react'
import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'

import ContactForm from './ContactForm'
import './Contact.scss'

Contact.propTypes = {
  selectedPack: PropTypes.string.isRequired,
}

function Contact({selectedPack}) {
  return (
    <ScrollableAnchor id="contact">
      <footer className="Contact">
        <div className="Contact-Background" />
        <div className="Container">
          <Grid container spacing={2}>
            <Hidden smDown>
              <Grid item md={1} lg={2} />
            </Hidden>
            <Grid item xs={12} md={10} lg={8}>
              <div className="Contact-Form">
                <Grid container spacing={2}>
                  <Hidden xsDown>
                    <Grid item xs={1} />
                  </Hidden>
                  <Grid item xs={12} sm={10}>
                    <h2 className="Contact-Title">Contact us</h2>
                  </Grid>
                  <Hidden xsDown>
                    <Grid item xs={1} />
                  </Hidden>
                </Grid>
                <Grid container spacing={2}>
                  <Hidden xsDown>
                    <Grid item xs={1} />
                  </Hidden>
                  <Grid item xs={12} sm={10}>
                    <ContactForm selectedPack={selectedPack} />
                  </Grid>
                  <Hidden xsDown>
                    <Grid item xs={1} />
                  </Hidden>
                </Grid>
              </div>
              <div className="Contact-Contacts">
                <p>25 jervois rd, ponsonby, auckland</p>
                <p>
                  <a className="Contact-Link" href="mailto:lite@7glyphs.com">
                    lite@7glyphs.com
                  </a>
                </p>
                <p>
                  <a className="Contact-Link" href="tel:0800459747">
                    0 800 459 747
                  </a>
                </p>
              </div>
            </Grid>
            <Hidden smDown>
              <Grid item md={1} lg={2} />
            </Hidden>
          </Grid>
        </div>
      </footer>
    </ScrollableAnchor>
  )
}

export default memo(Contact)
